import type { TableType } from './table.types'

export type TariffKind = 'USUAL' | 'MILITARY' | 'STUDENT'

export const TariffKind = {
    USUAL: 'USUAL',
    MILITARY: 'MILITARY',
    STUDENT: 'STUDENT',
} as const

export interface Tariff {
    id: number
    name: string
    tableType: TableType
    pricePerHour: number
    startTime: string | null  // HH:mm format
    endTime: string | null    // HH:mm format
    daysOfWeek: string | null // Comma-separated: MONDAY,TUESDAY...
    priority: number
    tariffKind: TariffKind
    isActive: boolean
}

// Request DTOs
export interface CreateTariffRequest {
    name: string
    tableType: TableType
    pricePerHour: number
    startTime?: string | null
    endTime?: string | null
    daysOfWeek?: string | null
    priority: number
    tariffKind?: TariffKind
    isActive?: boolean
}

export interface UpdateTariffRequest {
    name?: string
    pricePerHour?: number
    startTime?: string | null
    endTime?: string | null
    daysOfWeek?: string | null
    priority?: number
    tariffKind?: TariffKind
    isActive?: boolean
}

export interface CalculateCostRequest {
    tableType: TableType
    durationMinutes: number
    startTime?: string
}

export interface CalculateCostResponse {
    cost: number
    appliedTariff: Tariff
}

export interface SessionTariffOptions {
    maintenance: Tariff
    training: Tariff
}

export type SessionTariffMode = 'current' | 'training' | 'maintenance'
